<template>
  <div class="couponHistory">
    <section-header heading="2" ja="チケット・クーポン履歴"/>
    <div class="description">
      チケット・クーポンの購入・獲得・使用・消滅の履歴を確認できます<br>
      ※過去100件まで確認できます
    </div>
    <ul v-if="historyList" class="historyList">
      <li v-for="(item,index) in historyList.historyList" :key="index">
        <div class="title">{{item.name}}</div>
        <div class="data">
          <div>{{replaceTag(item.kindText)}}</div>
          <div>
            <span class="type">{{couponType(item.type)}}</span>
            <span class="date">{{toDate(item.createTime)}}</span>
          </div>
        </div>
      </li>
    </ul>
    <text-box v-else title="クーポン履歴はないよ"></text-box>
    <normal-btn @click="onCouponlist">戻る</normal-btn>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader'
import NormalBtn from '../components/NormalBtn'
import TextBox from '../components/TextBox'
import Protobuf from '../mixins/protobuf'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "couponHistory",
  components: {
    SectionHeader,
    NormalBtn,
    TextBox
  },
  mixins: [Protobuf],
  data() {
    return {
      historyList: null,
      detail: null
    }
  },
  computed: {
  },
  methods: {
    onCouponlist() {
      this.$router.push('/couponList')
    },
    toDate(intTime) {
      const padding = function (num) {
        return ('0' + num).slice(-2)
      }

      const date = new Date(1000 * intTime);
      const y = date.getFullYear();
      const m = padding(date.getMonth() + 1)
      const d = padding(date.getDate())
      const H = padding(date.getHours())
      const M = padding(date.getMinutes())
      return y + '/' + m + '/' + d + ' ' + H +':' + M
    },
    couponType(type) {
      switch(type) {
        case 1: return '獲得';
        case 2: return '使用';
        case 3: return '消滅';
        case 4: return '購入';
      }
    },
    replaceTag(text) {
      return text.replace(/(<([^>]+)>)/gi, '')
    }
  },
  mounted() {
    const cmdNo = pb.CouponHistoryReq.CommandNo.COMMAND_NO
    const message = pb.CouponHistoryReq.create()
    const encoded = pb.CouponHistoryReq.encode(message).finish()
    this.post(cmdNo, encoded)
      .then(decoded => {
        if (decoded === undefined) {
          this.$_error('Error', { title: 'クーポン', statusCode: 470 })
          return
        }
        this.historyList = decoded
      })
      .catch(() => {
        this.$_error('Error', {
          title: 'クーポン履歴',
          statusCode: 470
        })
      })
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.description {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
.historyList {
  margin-top: 40px;
  border-top: 1px solid #58575733;
  li {
    padding: 20px 30px;
    border-bottom: 1px solid #58575733;
    color: #373737;
    .title {
      font-size: 14px;
      font-weight: bold;
    }
    .data {
      display: flex;
      justify-content: space-between;
      margin-top: 5px;
      font-size: 10px;
      .date { margin-left: 10px; }
    }
  }
}
</style>
